var DtoMapper = /** @class */ (function () {
    function DtoMapper() {
    }
    DtoMapper.prototype.mapToModel = function (dto) {
        return dto;
    };
    DtoMapper.prototype.mapToDto = function (model) {
        return model;
    };
    DtoMapper.prototype.mapToModels = function (dtos) {
        var _this = this;
        return dtos.map(function (x) { return _this.mapToModel(x); });
    };
    DtoMapper.prototype.mapToDtos = function (models) {
        var _this = this;
        return models.map(function (x) { return _this.mapToDto(x); });
    };
    return DtoMapper;
}());
export default DtoMapper;
//# sourceMappingURL=DtoMapper.js.map